import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import Multiselect from 'vue-multiselect';
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      resultCount: 0,
      hubName: '',
      srcRuleName: '',
      srcClientName: '',
      srcHubName: '',
      srcConnectionName: '',
      srcConnectionNameData: [],
      HubNameData: [],
      DestHubNameData: [],
      allHubMaster: [],
      ClientNameData: [],
      srcRuleNameData: [],
      hubid: '',
      hubNameObjData: {
        value: "",
        text: ""
      },
      desthubNameObjData: {
        value: "",
        text: ""
      },
      srcConnectionObjData: {
        value: "",
        text: ""
      },
      destHubName: '',
      HubError: '',
      ConnectionError: '',
      connectionRight: '',
      searchConnectionRight: '',
      listSourceHubNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameData: [],
      listSourceHubNameData: [],
      searchConnection: '',
      searchHubId: '',
      noConnection: '',
      isClientLoaded: 0,
      createdBy: '',
      addmodalshow: false,
      modalShow: false,
      hubLoading: '',
      connectionLoading: '',

      //confirmlinehaulconnection
      Status: '',
      RouteMode: '',
      Coloader: '',
      Show: false,
      FromDate: '',
      ToDate: '',
      displayConnectionSchedule: false,
      lineHaulBagDetails: false,
      isColoaderError: '',
      coloaderlist: [],
      coloaderitem: {
        id: '',
        text: ''
      },
      coright: '',
      confirmLHC: {
        coloaderid: '',
        coloadername: '',
      },
      vehicleDataObj: {
        id: '',
        text: ''
      },
      editvehicleDataObj: {
        id: '',
        text: ''
      },
      vehicleNameData: [],
      editvehicleNameData: [],
      vehicleName: '',
      vehicleNo: '',
      editvehicleNo: '',
      vehicleLoading: '',
      isFromDateError: false,
      FromDateError: '',
      isToDateError: false,
      ToDateError: '',
      LineHaulDetails: [],
      LineHaulDetailsLstAll: [],
      LineHaulDetailsBag: [],
      checkAll: [],
      LHTrainFlightDetails: [],
      LineHaulDetailsData: [],
      offloadReasonData: [],
      selectedBags: [],
      showConnectionDetailsData: [],
      isLoadingSearch: false,
      AWBNo: '',
      pcTotalBag: '',
      totalColoaderPhyWt: '',
      totalColoaderVolWt: '',
      departureDate: '',
      departureTime: '',
      scheduleDate: '',
      arrivalDate: '',
      arrivalTime: '',
      confirm: false,
      completeOffloadcheck: false,
      partialOffloadcheck: false,
      ConfirmConnection: false,
      OffloadConnection: false,
      RescheduleConnection: false,
      connectionType: '',
      coloadername: '',
      coloaderid: '',
      coloaderIdForUpdate: '',
      xblhphywt: '',
      trainType: '',
      lineHaulDetailsID: '',
      boggieNo: '',
      breakNo: '',
      trainType: '',
      rrNo: '',
      firstRRNo: '',
      secondRRNo: '',
      xblhvolwt: '',
      ConnectionScheduleId: '',
      showTrainFields: false,
      showSurfaceFields: true,
      showFlightFields: false,
      LHTrainFlightDetailsID: '',
      lhtrainflightdetailsidUpdate: '',
      partialOffloadReason: {},
      completeOffloadReason: '',
      sAll: 0,
      connectionid: '',
      confirmedConnectionSchedule: false,
      confirmedConnectionScheduleData: [],
      HideDiv: true,
      isDisable: 1,
      updateConnection: false,
      confirmLineHaulDetailsId: '',
      linehaulstatus: '',
      validDateRange: '',
      today: '',
      isConnectionError: 0,
      ConnectionError: '',
      isColoaderError: 0,
      ColoaderError: '',
      limit: 10,
      totalRows: 0
    }
  },

  created: function() {},
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.createdBy = userdetail[0].email;
    this.today = new Date()

    this.getHubName();
  },
  created() {
    axios.interceptors.request.use((config) => {
      this.setLoading(true);
      return config;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.setLoading(false);
      return response;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });
  },
  methods: {
    changeStatus() {
      if (this.Status == "ConfirmeD") {
        this.RouteMode = '';
        this.Show = true;
      } else if (this.Status == "Pending") {
        this.srcConnectionObjData = {
          value: "",
          text: ""
        };
        this.coloaderitem = {
          id: '',
          text: ''
        };
        this.Show = false;
      }
    },

    setLoading(isLoading) {
      if (isLoading) {
        this.resultCount++;
        this.isLoading = true;
      } else if (this.resultCount > 0) {
        this.resultCount--;
        this.isLoading = (this.resultCount > 0);
      }
    },

    selectedHub(hubName) {
      this.hubNameObjData = hubName;
      this.srcHubName = this.hubNameObjData.text
      this.ConnectionError = ''
      this.hubNameObjData = hubName;
      var a = this.hubNameObjData.value
      this.DestHubNameData = this.allHubMaster.filter(function(el) {
        return el.value != a
      });
      this.hubName = hubName.value;
      this.srcHubName = hubName.value
      this.isConnectionError = 0
      this.ConnectionError = ''
      this.isColoaderError = 0;
      this.ColoaderError = ''
      this.srcConnectionObjData = {
        value: "",
        text: ""
      }
      this.getConnectionName();
    },
    selectedDestHub(destHub) {
      this.desthubNameObjData = destHub;
      this.destHubName = destHub.value
    },

    selectedConnection(connectionName) {
      this.ConnectionError = ''
      this.srcConnectionObjData = connectionName;
      this.connectionName = connectionName.value;
      this.srcConnectionName = connectionName.value;
      this.coloaderlist = [];
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.isConnectionError = 0;
      this.ConnectionError = '';
      this.isColoaderError = 0;
      this.ColoaderError = '';
      this.getColoder();
    },

    //to get hubname list start
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
            this.allHubMaster = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },
    getAllHubName() {
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.listSourceHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
    },

    //to get connection
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this;
      self.srcConnectionNameData = []
      this.resultCount = 0;
      if (self.hubNameObjData.value == undefined || self.hubNameObjData.value == null) {
        return false
      }
      this.input = {
        source: parseInt(self.hubNameObjData.value),
        "type": 3
      }
      this.isLoading = true
      self.connectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.connectionLoading = ''
          self.connectionRight = ''
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            this.isConnectionError = 0;
            this.ConnectionError = ''
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.srcConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName
              })
            }
          } else {
            this.isConnectionError = 1;
            this.ConnectionError = 'No Connection Found'
          }
        }, error => {
          self.connectionRight = ''
          this.isLoading = false
          this.connectionLoading = ''
          this.isConnectionError = 0;
          this.ConnectionError = ''
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },

    getConnectionNameSearch() {
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      self.noConnection = ''
      self.listConnectionNameData = []
      this.resultCount = 0;
      this.input = {
        source: parseInt(self.listSourceHubNameDataObj.value),
        type: 3
      }
      this.isLoading = true
      self.searchConnectionRight = this.rightLoader
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          self.searchConnectionRight = ''
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.listConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName
              })
            }
          } else {
            self.noConnection = 'No Connection Found'
          }
        }, error => {
          self.searchConnectionRight = ''
          this.isLoading = false
          self.noConnection = ''
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },

    SelectColoader(coloaderitem) {
      this.coloaderitem = coloaderitem;
      this.confirmLHC.coloadername = this.coloaderitem.text;
      this.confirmLHC.coloaderid = this.coloaderitem.id;
      if (this.confirmLHC.coloadername != '') {
        this.isColoaderError = '',
          this.Coloadererrors = ''
      } else {
        this.isColoaderError = '1',
          this.Coloadererrors = 'The Hub field is required.'
      }
      this.isColoaderError = 0;
      this.ColoaderError = ''
    },
    jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getColoder(issearch) {
      this.input = {
        hubid: this.hubNameObjData.value,
        connectionid: this.srcConnectionObjData.value,
        mode: this.jsUcfirst(this.RouteMode),
        isactive: 1
      };
      self.coright = self.ddloader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getcoloadermapping',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          self.coright = ''
          if (result.data.ResultCode == 100) {
            this.ColoderDetails = result.data.ResponseData
            this.isColoaderError = 0;
            this.ColoaderError = ''
            for (var i = 0; i < this.ColoderDetails.length; i++) {
              this.coloaderlist.push({
                "id": this.ColoderDetails[i].ColoaderID,
                "text": this.ColoderDetails[i].ColoaderName
              })
            }
          } else {
            this.isColoaderError = 1
            this.ColoaderError = 'No Coloader Found'
          }
        }, error => {
          self.coright = ''
          this.isColoaderError = 0;
          this.ColoaderError = ''
          console.error(error)
        })
    },
    getConnectionSchedule() {
      this.pageNo = 0
      this.showConnectionSchedule()
    },
    showConnectionSchedule() {
      this.totalRows = 0
      if (this.hubNameObjData.value == '' || this.RouteMode == '' || this.Status == '' || this.FromDate == '' || this.ToDate == '') {
        return false;
      }
      this.isLoading = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'LineHaulDetailsLstAll?offset=' + this.pageNo + '&limit=' + this.limit + '&HubID=' + this.hubNameObjData.value + '&RouteMode=' + this.RouteMode + '&LineHaulStatus=' + this.Status + '&ConnectionID=' + this.srcConnectionObjData.value + '&ColoaderID=' + this.coloaderitem.id + '&FromDate=' + moment(this.FromDate).format('YYYY-MM-DD') + '&ToDate=' + moment(this.ToDate).format('YYYY-MM-DD') + '',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          this.LineHaulDetailsBag = [];
          this.lineHaulBagDetails = false;
          this.resetForm();
          this.resetChangeConnectionForm();
          this.$validator.reset();
          this.errors.clear();


          if (result.data.ResultCode == 100) {
            this.displayConnectionSchedule = true;
            this.LineHaulDetailsLstAll = result.data.ResultData;
            this.totalRows = result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
            this.displayConnectionSchedule = false;
            this.LineHaulDetailsLstAll = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.showConnectionSchedule()
    },
    selectVehicle(vehicleName) {
      this.vehicleDataObj = vehicleName;
      this.vehicleNo = this.vehicleDataObj.text
    },
    selectEditVehicle(editvehicleDataObj) {
      this.editvehicleDataObj = editvehicleDataObj;
      this.editvehicleNo = this.editvehicleDataObj.text
    },
    showBagDetails(data) {
      this.coloaderid = data.coloaderid;
      this.coloadername = data.coloadername;
      this.connectionid = data.connectionid;
      this.LHTrainFlightDetailsID = data.lhtrainflightdetailsid;
      if (data.linehauldetailsid == '' || data.linehauldetailsid == undefined || data.linehauldetailsid == null) {
        return false;
      }
      this.lineHaulDetailsID = data.linehauldetailsid;
      this.ConnectionScheduleId = data.connectionscheduleid;

      this.isLoading = true;
      if (this.Status == "ConfirmeD" || this.Status == "Pending") {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'showBagDetailsByLinehaulDetailsId?LineHaulDetailsID=' + data.linehauldetailsid,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              this.lineHaulBagDetails = true;
              this.LineHaulDetailsBag = result.data.ResponseData;
              let totalRows = this.LineHaulDetailsBag.length
              if (totalRows < 10) {
                this.pageCountrule = 1
              } else {
                this.pageCountrule = Math.ceil(totalRows / 10);
              }
            } else {
              this.LineHaulDetailsBag = [];
              this.lineHaulBagDetails = false;
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            self.coright = ''
            console.error(error)
          })

        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getConfirmLineHaulDetailsByLineHaulId?LineHaulDetailsID=' + data.linehauldetailsid,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              this.confirmedConnectionSchedule = true;
              this.confirmedConnectionScheduleData = result.data.ResultData;
              let totalRows = this.confirmedConnectionScheduleData.length
              if (totalRows < 10) {
                this.pageCountrule = 1
              } else {
                this.pageCountrule = Math.ceil(totalRows / 10);
              }
            } else {
              this.ConfirmConnection = false;
              this.OffloadConnection = false;
              this.RescheduleConnection = false;
              this.confirmedConnectionScheduleData = [];
              //this.$alertify.error(result.data.ReturnMessage)
              console.log(result.data.ReturnMessage + " of getConfirmLineHaulDetailsByLineHaulId");
            }
          }, error => {
            self.coright = ''
            console.error(error)
          })
      }
      // } else if (this.Status != "ConfirmeD") {
      //   axios({
      //       method: 'GET',
      //       url: apiUrl.api_url_hubops + 'showBagDetailsByLinehaulDetailsId?LineHaulDetailsID=' + data.linehauldetailsid,
      //       headers: {
      //         'authorization': 'authkey xB84JJ89Hd25'
      //       }
      //     })
      //     .then(result => {
      //       this.isLoading = false;
      //       if (result.data.ResultCode == 100) {
      //         this.lineHaulBagDetails = true;
      //         this.LineHaulDetailsBag = result.data.ResponseData;
      //         let totalRows = this.LineHaulDetailsBag.length
      //         if (totalRows < 10) {
      //           this.pageCountrule = 1
      //         } else {
      //           this.pageCountrule = Math.ceil(totalRows / 10);
      //         }
      //       } else {
      //         this.LineHaulDetailsBag = [];
      //         this.lineHaulBagDetails = false;
      //         // console.log(result.data.ReturnMessage);
      //         this.$alertify.error(result.data.ReturnMessage)
      //       }
      //     }, error => {
      //       self.coright = ''
      //       console.error(error)
      //     })
      // }
    },
    showConnectionDetails(data) {
      this.updateConnection = true;
      this.HideDiv = false;
      this.isDisable = 0;
      this.ConfirmConnection = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'confirmLineHaulDetailsListAll?LineHaulDetailsID=' + data.linehauldetailsid + '&ConfirmLineHaulDetailsID=' + data.confirmlinehauldetailsid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            var data = result.data.ResultData[0];
            // console.log(data);
            this.coloaderIdForUpdate = data.coloaderid;
            if (data.routemode == 'Surface' || data.routemode == 'surface') {
              this.RouteMode = 'surface';
            } else if (data.routemode == 'Air' || data.routemode == 'air') {
              this.RouteMode = 'air';
            } else if (data.routemode == 'Train' || data.routemode == 'train') {
              this.RouteMode = 'train';
            }
            if (data.linehaulstatus == 'Confirmed' || data.linehaulstatus == 'confirmed') {
              this.Status = 'ConfirmeD';
              this.linehaulstatus = data.linehaulstatus;
            } else if (data.linehaulstatus == 'Pending' || data.linehaulstatus == 'pending') {
              this.Status = 'Pending';
            }
            this.arrivalDate = data.arrivaldate;
            this.arrivalTime = data.arrivaltime;
            this.AWBNo = data.awbno;
            this.boggieNo = data.boggieno;
            this.breakNo = data.breakno;
            this.departureDate = data.departuredate;
            this.departureTime = data.departuretime;
            this.pcTotalBag = data.pcs;
            this.totalColoaderPhyWt = data.physicalweight;
            this.totalColoaderVolWt = data.volumetricweight;
            this.RRNo = data.rrno;
            this.firstRRNo = data.rrno1;
            this.secondRRNo = data.rrno2;
            this.scheduleDate = new Date(data.scheduledate);
            this.trainType = data.traintype;
            this.vehicleDataObj = {
              value: data.vehicleno,
              text: data.vehiclename
            };
            this.vehicleNameData.push({
              text: data.vehiclename,
              value: data.vehicleno
            });
            this.vehicleNo = data.vehicleno;
            this.confirm = "confirm";
            this.confirmLineHaulDetailsId = data.confirmlinehauldetailsid;
            this.lhtrainflightdetailsidUpdate = data.lhtrainflightdetailsid;
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    connectionUpdate() {
      // this.$alertify.error("API Nahi Dili Na Ajun Bhau...!!!!!!!!!!!!")
      // return false;
      this.inputUpdate = {
        ColoaderID: this.coloaderIdForUpdate,
        routemode: this.RouteMode,
        linehaulstatus: this.Status,
        ArrivalDate: moment(this.arrivalDate).format('YYYY-MM-DD'),
        ArrivalTime: this.arrivalTime,
        AWBNo: this.AWBNo,
        BoggieNo: this.boggieNo,
        BreakNo: this.breakNo,
        DepartureDate: moment(this.departureDate).format('YYYY-MM-DD'),
        DepartureTime: this.departureTime,
        Pcs: this.pcTotalBag,
        PhysicalWeight: this.totalColoaderPhyWt,
        VolumetricWeight: this.totalColoaderVolWt,
        RRNo: this.RRNo,
        RRNo1: this.firstRRNo,
        RRNo2: this.secondRRNo,
        ScheduleDate: moment(this.scheduleDate).format('YYYY-MM-DD'),
        TrainType: this.trainType,
        VehicleName: this.vehicleDataObj.text,
        VehicleNo: this.vehicleDataObj.value,
        ConfirmLineHaulDetailsID: this.confirmLineHaulDetailsId,
        LastModifiedBy: this.createdBy,
        LHTrainFlightDetailsID: this.lhtrainflightdetailsidUpdate
      }

      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'confirmLineHaulDetailsUpdate',
          data: this.inputUpdate,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    selectAll() {
      this.sAll == 1 ? 0 : 1
      if (this.sAll == 1) {
        this.LineHaulDetailsBag.forEach((data) => {
          this.selectedBags.indexOf(data.connectionscheduleid) == -1 ? this.selectedBags.push({
            connectionscheduleid: data.connectionscheduleid,
            bagno: data.bagno
          }) : ''
        })
        this.pcTotalBag = this.selectedBags.length;
      } else {
        this.selectedBags = []
      }
    },
    selectedBagsData() {
      this.pcTotalBag = this.selectedBags.length;
    },
    changeConnection() {
      if (this.connectionType == "ConfirmConnection") {
        if (this.selectedBags.length <= 0) {
          return false
        }
        //bellow if else to show lebel as per route mode
        if (this.RouteMode == "train") {
          this.showTrainFields = true;
          this.showSurfaceFields = false;
          this.showFlightFields = false;
        } else if (this.RouteMode == "air") {
          this.showFlightFields = true;
          this.showSurfaceFields = false;
          this.showTrainFields = false;
        } else if (this.RouteMode == "surface") {
          this.showSurfaceFields = true;
          this.showTrainFields = false;
          this.showFlightFields = false;
        }
        if (this.RouteMode == "surface" || this.RouteMode == "air" || this.RouteMode == "train") {
          this.input1 = {
            RouteMode: this.jsUcfirst(this.RouteMode),
            ConnectionID: this.connectionid,
            ColoaderID: this.coloaderid
          }
          axios({
              'method': 'POST',
              'url': apiUrl.api_url_hubops + 'getLHTrainFlightDetails',
              'data': this.input1,
              'headers': {
                'authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
              this.vehicleLoading = 'Loading vehicles...'
              if (result.data.ResultCode == 100) {
                this.LHTrainFlightDetails = result.data;
                // this.LHTrainFlightDetailsID = this.LHTrainFlightDetails.data[0].LHTrainFlightDetailsID;

                this.input2 = {
                  lhtrainflightdetailsid: this.LHTrainFlightDetailsID,
                  // lhtrainflightdetailsid: 14,
                }
                axios({
                    'method': 'POST',
                    'url': apiUrl.api_url_hubops + 'getlinehaulDetails',
                    'data': this.input2,
                    'headers': {
                      'authorization': 'authkey xB84JJ89Hd25'
                    }
                  })
                  .then(result => {
                    this.vehicleNameData = [];
                    if (result.data.ResultCode == 100) {
                      var date = new Date();
                      this.LineHaulDetailsData = result.data.ResponseData;
                      this.departureDate = this.LineHaulDetailsData[0].DepartureDate == null || this.LineHaulDetailsData[0].DepartureDate == '' ? '' : new Date(this.LineHaulDetailsData[0].DepartureDate);
                      this.departureTime = this.LineHaulDetailsData[0].ETD == null || this.LineHaulDetailsData[0].ETD == '' ? '' : this.LineHaulDetailsData[0].ETD;
                      this.scheduleDate = new Date(date);
                      this.arrivalDate = this.LineHaulDetailsData[0].ArrivalDate == null || this.LineHaulDetailsData[0].ArrivalDate == '' ? '' : new Date(this.LineHaulDetailsData[0].ArrivalDate);
                      this.arrivalTime = this.LineHaulDetailsData[0].ETA == null || this.LineHaulDetailsData[0].ETA == '' ? '' : this.LineHaulDetailsData[0].ETA;

                      this.vehicleLoading = ''
                      var vehicleNameData = result.data.ResponseData

                      if (this.RouteMode == "surface") {
                        for (var i = 0; i < vehicleNameData.length; i++) {
                          this.vehicleNameData.push({
                            value: vehicleNameData[i].ETA,
                            text: 'ETA ' + vehicleNameData[i].ETA + ' - ETD ' + vehicleNameData[i].ETD
                          })
                        }
                      } else if (this.RouteMode == "air" || this.RouteMode == "train") {
                        for (var i = 0; i < vehicleNameData.length; i++) {
                          this.vehicleNameData.push({
                            value: vehicleNameData[i].EntityNumber,
                            text: vehicleNameData[i].EntityName + ' (' + vehicleNameData[i].EntityNumber + ')'
                          })
                        }
                      }

                      this.boggieNo = this.LineHaulDetailsData[0].boggieno;
                      this.RRNo = this.LineHaulDetailsData[0].rrno;
                      this.firstRRNo = this.LineHaulDetailsData[0].rrno1;
                      this.secondRRNo = this.LineHaulDetailsData[0].rrno2;
                      this.breakNo = this.LineHaulDetailsData[0].breakno;
                    } else {
                      this.$alertify.error(result.data.ReturnMessage)
                    }
                  }, error => {
                    console.error(error)
                  });
              } else {
                this.$alertify.error(result.data.ReturnMessage)
              }
            }, error => {
              console.error(error)
            });
        }
        // console.log(this.lineHaulDetailsID);
        this.ConfirmConnection = true;
        this.OffloadConnection = false;
        this.RescheduleConnection = false;
      } else if (this.connectionType == "OffloadConnection") {
        if (this.selectedBags.length <= 0) {
          return false
        }
        this.offloadReasonMaster();
        this.ConfirmConnection = false;
        this.OffloadConnection = true;
        this.RescheduleConnection = false;
      } else if (this.connectionType == "RescheduleConnection") {
        if (this.selectedBags.length <= 0) {
          return false
        }
        this.offloadReasonMaster();
        this.ConfirmConnection = false;
        this.OffloadConnection = false;
        this.RescheduleConnection = true;
      }
    },
    connectionConfirm() {
      var connectionScheduleId = [];
      if (this.AWBNo == '' || this.AWBNo == undefined) {
        return false;
      }
      for (var i = 0; i < this.selectedBags.length; i++) {
        connectionScheduleId.push(this.selectedBags[i].connectionscheduleid);
      }
      this.input = {
        LineHaulDetailsID: this.lineHaulDetailsID,
        VehicleName: this.vehicleDataObj.text,
        VehicleNo: this.vehicleDataObj.value,
        AWBNo: this.AWBNo,
        Pcs: this.pcTotalBag,
        PhysicalWeight: this.totalColoaderPhyWt,
        VolumetricWeight: this.totalColoaderVolWt,
        ScheduleDate: moment(this.scheduleDate).format('YYYY-MM-DD'),
        DepartureDate: moment(this.departureDate).format('YYYY-MM-DD'),
        DepartureTime: this.departureTime,
        ArrivalDate: moment(this.arrivalDate).format('YYYY-MM-DD'),
        ArrivalTime: this.arrivalTime,
        BoggieNo: this.boggieNo,
        RRNo: this.rrNo,
        RRNo1: this.firstRRNo,
        RRNo2: this.secondRRNo,
        BreakNo: this.breakNo,
        TrainType: this.trainType,
        LastModifiedBy: this.createdBy,
        ConnectionScheduleIds: connectionScheduleId,
        IsCargoConfirm: false,
        XBPhysicalWeight: this.xblhphywt,
        XBVolumetricWeight: this.xblhvolwt,
        LHTrainFlightDetailsID: this.LHTrainFlightDetailsID
      };
      // return false;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'updateLineHaulDetails',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            connectionScheduleId = [];
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    offloadReasonMaster() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getOffloadReasons?OffloadReasonType=LHCOOffload',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.offloadReasonData = result.data.ResponseData;
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          self.coright = ''
          console.error(error)
        })
    },
    partialOffload() {
      var bagNo = [];
      var finalBagNo = '';
      for (var i = 0; i < this.selectedBags.length; i++) {
        bagNo.push(this.selectedBags[i].bagno);
      }
      finalBagNo = bagNo.toString();

      this.input = {
        HubID: this.hubNameObjData.value,
        LineHaulDetailsID: this.lineHaulDetailsID,
        BagNos: finalBagNo,
        OffloadStatusCode: this.partialOffloadReason.offloadstatuscode,
        OffloadReasonType: this.partialOffloadReason.offloadreasontype,
        LastModifiedBy: this.createdBy,
        Action: "OffloadConnection"
      }
      bagNo = [];
      finalBagNo = '';
      this.partialOffloadReason = {};
      // return false;
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'offLoadBagMaster',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            bagNo = [];
            finalBagNo = '';
            this.partialOffloadReason = {};
            this.partialOffloadcheck = false
            this.sAll = 0
            this.selectedBags = [];
            this.$validator.reset()
            this.showConnectionSchedule()
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },
    completeOffload() {
      if (this.LineHaulDetailsBag.length != this.selectedBags.length) {
        this.$alertify.error("Please select all bags");
        return false;
      }
      var bagNo = [];
      var finalBagNo = '';
      for (var i = 0; i < this.selectedBags.length; i++) {
        bagNo.push(this.selectedBags[i].bagno);
      }
      finalBagNo = bagNo.toString();
      this.input = {
        HubID: this.hubNameObjData.value,
        LineHaulDetailsID: this.lineHaulDetailsID,
        BagNos: finalBagNo,
        OffloadStatusCode: this.completeOffloadReason.offloadstatuscode,
        OffloadReasonType: this.completeOffloadReason.offloadreasontype,
        LastModifiedBy: this.createdBy,
        Action: "RescheduleConnection"
      }
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'offLoadBagMaster',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            bagNo = [];
            finalBagNo = '';
            this.partialOffloadReason = {};
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll('form-1').then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    onSubmitSelectConnection: function() {
      var self = this
      this.$validator.validateAll('form-2').then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    onSubmitConfirmConnection: function() {
      var self = this
      this.$validator.validateAll('form-3').then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    onSubmitOffloadConnection: function() {
      var self = this
      this.$validator.validateAll('form-4').then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    onSubmitRescheduleConnection: function() {
      var self = this
      this.$validator.validateAll('form-5').then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },

    //to reset search form
    resetForm() {
      this.confirmedConnectionSchedule = false;
      this.confirmedConnectionScheduleData = [];
      this.lineHaulBagDetails = false;
      this.LineHaulDetailsBag = [];
      this.ConfirmConnection = false;
      this.isLoading = false;
      // this.hubName = '';
      // this.srcRuleName = '';
      // this.srcClientName = '';
      this.srcHubName = '';
      // this.srcConnectionName = '';
      // this.hubid = '';
      // this.hubNameObjData = {
      //   value: "",
      //   text: ""
      // };
      // this.desthubNameObjData = {
      //   value: "",
      //   text: ""
      // };
      this.vehicleDataObj = {
        id: '',
        text: ''
      };
      // this.destHubName = '';
      // this.ConnectionError = '';
      // this.srcConnectionNameData = [];
      this.vehicleNameData = [];
      this.confirmLHC = {};
      this.coloaderlist = [];
      this.selectedBags = [];
      this.AWBNo = '';
      this.xblhphywt = '';
      this.xblhvolwt = '';
      this.totalColoaderPhyWt = '';
      this.totalColoaderVolWt = '';
      this.pcTotalBag = '';
      this.boggieNo = '';
      this.breakNo = '';
      this.trainType = '';
      this.rrNo = '';
      this.firstRRNo = '';
      this.secondRRNo = '';
      this.departureDate = '';
      this.departureTime = '';
      this.scheduleDate = '';
      this.arrivalDate = '';
      this.arrivalTime = '';
      this.confirm = '';
      this.$validator.reset();
      this.errors.clear();
    },
    resetSearchForm() {
      this.isLoading = false;
      this.Status = '';
      this.srcConnectionName = '';
      this.RouteMode = '';
      this.hubNameObjData = {
        value: "",
        text: ""
      };
      this.desthubNameObjData = {
        value: "",
        text: ""
      };
      this.srcConnectionObjData = {
        value: "",
        text: ""
      };
      this.coloaderitem = {
        id: '',
        text: ''
      };
      this.FromDate = '';
      this.ToDate = '';
      this.isConnectionError = 0;
      this.ConnectionError = '';
      this.isColoaderError = 0;
      this.ColoaderError = '';
      this.Show = false;
      this.LineHaulDetailsLstAll = [];
      this.displayConnectionSchedule = false;
      this.LineHaulDetailsBag = [];
      this.lineHaulBagDetails = false;
      this.resetForm();
      this.resetChangeConnectionForm();
      this.$validator.reset();
      this.errors.clear();
    },
    resetChangeConnectionForm() {
      this.resetForm();
      this.partialOffloadReason = {};
      this.OffloadConnection = false;
      this.RescheduleConnection = false;
      this.isLoading = false;
      this.confirmedConnectionSchedule = false;
      this.confirmedConnectionScheduleData = [];
      this.connectionType = '';
      this.isConnectionError = 0;
      this.ConnectionError = '';
      this.isColoaderError = 0;
      this.ColoaderError = '';
      this.$validator.reset();
      this.errors.clear();
    },
    printLineHaulConnection(data) {
      this.$router.push("/lineHaulPrint/" + data.linehauldetailsid + "/" + data.confirmlinehauldetailsid)
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/ConfirmLineHaulConnection/ConfirmLineHaulConnection.js